import classNames from 'classnames';
import { useId } from 'react';

import LoadingIcon from '../icons/LoadingIcon';

import styles from '../../styles/fields/radios-field.module.css';

interface RadiosFieldProps {
    type: string;
    name: string;
    errors?: string[] | null;
    value?: string | null;
    options: FieldOption[];
    loading?: boolean;
    className?: string;
    onChange: (value: string | null) => void;
}

function RadiosField({
    type,
    name,
    value,
    errors = null,
    options,
    loading = false,
    className,
    onChange = null,
}: RadiosFieldProps) {
    const id = useId();
    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked, value: inputValue } = event.currentTarget;
        if (checked && onChange !== null) {
            onChange(inputValue);
        }
    };

    const hasErrors = errors !== null && errors.length > 0;

    return (
        <div
            className={classNames([styles.container, { [styles.hasErrors]: hasErrors }, className])}
            data-theme={type}
        >
            <div className={styles.options}>
                {options.map(({ value: optionValue, label: optionLabel }, index) => {
                    const isAnswer = value === optionValue;
                    return (
                        <div
                            key={`option-${optionValue}`}
                            className={classNames([
                                styles.option,
                                {
                                    [styles.loading]: loading && isAnswer,
                                    [styles.notSelected]: value !== null && !isAnswer,
                                    [styles.selected]: isAnswer,
                                },
                            ])}
                        >
                            <input
                                type="radio"
                                id={`${id}-${optionValue}`}
                                name={name}
                                value={optionValue}
                                checked={isAnswer}
                                onChange={onInputChange}
                                className={styles.input}
                            />
                            <label htmlFor={`${id}-${optionValue}`} className={styles.button}>
                                <span className={styles.prefix}>
                                    <span className={styles.index}>{index + 1}</span>
                                    <LoadingIcon className={styles.loadingIcon} />
                                </span>
                                <span className={styles.label}>{optionLabel}</span>
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default RadiosField;
